import { useCallback, useState } from "react";

/**
 * Shows the Eleven Labs beta disclaimer before applying an ai_agent call action.
 * Returns requestConfirmation(callback) — call it instead of proceeding directly when actionType is ai_agent.
 */
export function useElevenLabsDisclaimer() {
  const [open, setOpen] = useState(false);
  const [pendingConfirm, setPendingConfirm] = useState(null);

  const requestConfirmation = useCallback((onConfirmed) => {
    setPendingConfirm(() => onConfirmed);
    setOpen(true);
  }, []);

  const acknowledge = useCallback(() => {
    if (pendingConfirm) pendingConfirm();
    setPendingConfirm(null);
    setOpen(false);
  }, [pendingConfirm]);

  const cancel = useCallback(() => {
    setPendingConfirm(null);
    setOpen(false);
  }, []);

  return {
    requestConfirmation,
    disclaimerOpen: open,
    acknowledgeDisclaimer: acknowledge,
    cancelDisclaimer: cancel,
  };
}
